

















































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Mixins, Watch, Emit } from 'vue-property-decorator';
import multiselect from 'vue-multiselect';
import Combobox from '../../core/components/Combobox.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import InputFile from '../../core/components/InputFile.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import PlusEyeButtons from '../../core/components/PlusEyeButtons.vue';
import { InsuranceServices } from '../api/InsuranceServices';
import LoadingDialog from '../../core/components/LoadingDialog.vue';
import DetailHarvestSowing from './farming/DetailHarvestSowing.vue';
import $ from 'jquery';

import {
    // AuthStoreHelper,
    RootStoreHelper, NotificationStoreHelper
    // CompanyStoreHelper,
    // StoreHelper,
    // NotificationStoreHelper
} from '../../core/mixins';
import {
    sortObjectByPropertyName,
    splitStringByIndex,
    matchedIndexIdInArray,
    addItemsToListIfAreNotAdded,
    removeItemsFromList,
    getIdsFromList,
    toFindDuplicates,
    parseFloatNumber,
    formatDate,
    getUniqueId,
    EventBus,
    TypeEventBus,
    removeItemFromLocalStorage,
    getDateAsMoment,
    addTimeToDate,
    getDateFormattedAsMoment,
    substractTimeToDate,
    PRIVILEGE_KEYS,
    itemsPerPageOptionsTable,
    NAME_ROUTES,
} from '../../core/utils';
import moment from 'moment';
import { dateTypes, diffOptions } from '../../core/models';
import vColumnsResizable from '../../../plugins/vue-columns-resizable'

@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: {
        multiselect,
        Combobox,
        Button,
        DatePickerRange,
        SimpleTable,
        SimpleMap,
        DetailHarvestSowing,
        TableArrows,
        PlusEyeButtons,
        Input,
        InputFile,
        ModalInsuranceHarvest: () => import('./ModalInsuranceHarvest.vue')
    }
})
export default class FarmingDetail extends Mixins(RootStoreHelper, NotificationStoreHelper) {
    @Prop({ default: false }) editing: boolean;
    @Prop({ default: false }) optionsInsuranceCompanies: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    optionsFarmings: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    cropTypeOptions: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    ranchStates: Array<object>;
    @Prop({ default: {} }) patchData: object;
    detailCompanyFarming: object | null = null;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;

    // @Prop({default: []}) optionsInsuranceCompany: any;
    optionsCompany: Array<object> = [];
    // @Prop({default: []}) optionsSecuredCompanies: any;
    optionsInsuranceCompany: Array<object> = [];
    // securedCompanies: Array<object> = [];

    modalTitle: string = '';
    prefix: string = '';
    startYear: string = '';
    endYear: string = '';
    dateRangeSelected: any = [];
    dateRangeHarvest: any = [];
    dateRangeSowing: any = [];
    fileSelected: any = [];
    readers: any = [];
    enableMultiple: boolean = false;
    enableCreateHarvest: boolean = true;
    enableCreateSowing: boolean = false;
    activeRanch: boolean = true;
    firstTab: string = 'select_file';
    secondTab: string = 'view_table';

    //selectors
    cropTypeSelected: any = null;
    companySelected: any = null;
    insuranceHarvestSelected: any = null;
    fileCompanyId: any = null;
    filePolicySelected: any = null;
    // fileAreaPolicySelected: any = null;
    fileHarvestName: any = null;

    //selectors reset values
    cropTypeRV: boolean = false;
    insuranceCompanyRV: boolean = false;
    insuranceHarvestRV: boolean = false;
    fileCompanyIdRV: boolean = false;
    filePolicyRV: boolean = false;
    // fileAreaPolicyRV: boolean = false;
    fileHarvestRV: boolean = false;
    loadingPatchInsuranceFarming: boolean = false;
    geoJsonLoaded: boolean = false;
    keepThisModalOpen: boolean = false;
    zafraName: string = '';
    farmingYear: string = '';

    cropType: Array<object> = [];

    //selector options
    itemsAvailableCompanies: Array<object> = [];
    itemsAvailableCompaniesSelected: Array<object> = [];
    itemsSelectedCompanies: Array<object> = [];
    selectedCompaniesToExclude: Array<object> = [];
    previewHeaders: Array<object> = [];
    fileOptions: Array<object> = [];
    headersAvailableCompanies: Array<object> = [
        {
            text: 'Empresa',
            value: 'name',
            sortable: true
        },
        {
            text: 'Zafra',
            value: 'harvest',
            sortable: true
        }
    ];
    headersSelectedCompanies: Array<object> = [
        {
            text: 'Empresa',
            value: 'name',
            sortable: true
        },
        {
            text: 'Zafra',
            value: 'harvest',
            sortable: true
        },
        {
            text: 'Alertas',
            value: 'alerts',
            align: 'center'
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: true
        }
    ];
    previewItems: Array<object> = [];
    itemsPreviewGeojsonSelected: Array<object> = [];
    harvestPanelModel: number | null = null;
    sowingPanelModel: number | null = null;

    visibleModalInsuranceHarvest: boolean = false;
    editInsuranceHarvest: boolean = false;
    insuranceFarmingToPatch: object = {};
    invalidSelectedCompanies: number = 0;
    geoJsonFile: any = [];
    geoJsonFormData: any = [];

    fileErrorCompanyId: boolean = false;
    fileErrorPolicy: boolean = false;
    // fileErrorPolicyArea: boolean = false;
    fileErrorHarvest: boolean = false;
    selectedRanchs: any = [];
    selectedFeatures: Array<object> = [];
    searchAvailableCompanies: string = '';

    updatesearchAvailableCompanies(value) {
        this.searchAvailableCompanies = value;
    }

    visibilityModalInsuranceHarvest(value) {
        this.visibleModalInsuranceHarvest = value;
    }

    changeMultipleSelector(value) {
        if (value) {
            this.enableCreateHarvest = true;
        } else {
            this.enableCreateHarvest = false;
        }
    }


    changeCreateSowing(value) {
        if (value && this.dateRangeSelected.length > 0) {
            setTimeout(() => {
                this.setDefaultSowingDates();
            }, 0);
        } else {
            setTimeout(() => {
                this.updateRangeDateSowing([]);
            }, 0);
        }
    }

    changeCreateHarvest() {
        this.enableCreateHarvest = true;
    }

    @Watch('insuranceHarvestSelected', { deep: true, immediate: true })
    observableInsuranceHarvest(value) {
        this.filterCompanies(value);
        this.checkIfSelectedCompaniesBelongsToSelectedHarvest();
    }

    @Watch('fileCompanyId')
    @Watch('filePolicySelected')
    @Watch('fileHarvestName')
    observableFileColumns() {
        this.fileErrorCompanyId = false;
        this.fileErrorPolicy = false;
        //  this.fileErrorPolicyArea = false;
        this.fileErrorHarvest = false;
        if (
            this.fileCompanyId !== null &&
            this.filePolicySelected !== null &&
            // this.fileAreaPolicySelected !== null &&
            this.fileHarvestName
        ) {
            let selectedValues = [
                this.fileCompanyId['value'],
                this.filePolicySelected['value'],
                //    this.fileAreaPolicySelected['value'],
                this.fileHarvestName['value']
            ];

            let duplicatedColumnsSelected = toFindDuplicates(selectedValues);

            if (duplicatedColumnsSelected.length !== 0) {
                for (let index = 0; index < duplicatedColumnsSelected.length; index++) {
                    const column = duplicatedColumnsSelected[index];

                    switch (column) {
                        case 0:
                            this.fileErrorCompanyId = true;
                            break;
                        case 1:
                            this.fileErrorPolicy = true;
                            break;
                        case 2:
                            this.fileErrorHarvest = true;
                            break;
                    }
                }
            }
        }
    }

    updatecompanySelected(value) {
        this.companySelected = value;
    }
    updateInsuranceCompanyRV(value) {
        this.insuranceCompanyRV = value;
    }
    updateCropTypeSelected(value) {
        this.cropTypeSelected = value;
    }
    updateCropTypeRV(value) {
        this.cropTypeRV = value;
    }
    updateInsuranceHarvestSelected(value) {
        this.insuranceHarvestSelected = value;
        this.preloadInsuranceFarmingData(value);
        if (value == null) {
            this.enableCreateSowing = false;
            this.updateRangeDateHarvest([]);
            this.updateRangeDateSowing([]);
        }
    }
    updateInsuranceHarvestRV(value) {
        this.insuranceHarvestRV = value;
    }
    updatePreffixValue(value) {
        this.prefix = value;
    }
    updateFileCompanyId(value) {
        this.fileCompanyId = value;
    }
    updateFileCompanyRV(value) {
        this.fileCompanyIdRV = value;
    }
    updateFilePolicy(value) {
        this.filePolicySelected = value;
    }
    updateFilePolicyRV(value) {
        this.filePolicyRV = value;
    }
    // updateFilePolicyArea(value){this.fileAreaPolicySelected = value;}
    // updateFilePolicyAreaRV(value){this.fileAreaPolicyRV = value};
    updateFileHarvest(value) {
        this.fileHarvestName = value;
    }
    updateFileHarvestRV(value) {
        this.fileHarvestRV = value;
    }
    updateZafraName(value) {
        this.zafraName = value;
    }
    uploadedFile(file) {
        this.fileSelected = file;
    }

    selectAllRanchs(itemsList) {
        this.selectedRanchs = [];
        if (!itemsList['value']) {
            itemsList['items'].forEach(item => {
                this.mapCompanyHarvest.unselectFeature(item);
            });
        } else {
            itemsList['items'].forEach(element => {
                this.tableRanchClicked(element);
            });
        }
    }



    preloadInsuranceFarmingData(data) {
        if (!this.editing) {
            if (data !== null) {
                let indexCropType = matchedIndexIdInArray(this.cropTypeOptions, data['harvest_type'].toString());
                if (indexCropType !== -1) {
                    this.updateCropTypeSelected(this.cropTypeOptions[indexCropType]);
                }
                this.updateZafraName(data['name']);
                this.updatePreffixValue(this.zafraName);
                this.updateRangeDate([data['start_date'], data['end_date']]);
            } else {
                this.updateZafraName('');
                this.updateCropTypeSelected(null);
                this.updatePreffixValue('');
                this.updateRangeDate([]);
            }
        }
    }

    uploadFile() {
        this.fileOptions = [];
        this.updateFileCompanyId(null);
        this.updateFilePolicy(null);
        this.updateFileHarvest(null);
        this.geoJsonLoaded = false;
        let reader = new FileReader();
        let self = this;
        this.geoJsonFormData = this.fileSelected[0];
        reader.readAsText(this.fileSelected[0]);
        reader.onload = (e: any) => {
            let lines = e.target.result;
            let newArr = JSON.parse(lines);
            self.geoJsonLoaded = true;
            self.geoJsonToTableFormat(newArr);
        };
    }

    geoJsonToTableFormat(geoJSON) {
        let previewHeaders: Array<object> = [];
        let features = geoJSON['features'];
        features.forEach(item => {
            item['id'] = getUniqueId();
            (item['properties']['customId'] = getUniqueId()), (item['selected'] = 'false');
        });
        this.mapCompanyHarvest.addGeoJson(geoJSON);

        this.previewItems = features;
        this.previewHeaders = [];
        let geojsonProperties = geoJSON.features[0].properties;
        if (Object.values(geojsonProperties).length !== 0) {
            let index = 0;
            for (let key in geojsonProperties) {
                previewHeaders.push({
                    id: index++,
                    text: key,
                    value: key,
                    sortable: true,
                    width: '130px'
                });
            }

            this.previewHeaders = previewHeaders.filter(function(item) {
                return item['text'] !== 'customId';
            });
            this.fileOptions = previewHeaders;
        }
    }

    updateRangeDateSowing(value) {
        this.dateRangeSowing = [];
        this.dateRangeSowing = value;
    }

    updateRangeDateHarvest(value) {
        this.dateRangeHarvest = [];
        this.dateRangeHarvest = value;
    }

    updateRangeDate(value) {
        this.dateRangeSelected = [];
        this.dateRangeSelected = value;
        if (value.length > 0) {
            if (this.enableCreateSowing) {
                this.setDefaultSowingDates();
            }
            this.setDefaultHarvestDates();
        }
    }

    receivedText(e) {
        let lines = e.target.result;
        let newArr = JSON.parse(lines);

        return newArr;
    }

    mounted() {
        this.setModalTitle();
        this.loadPatchData();
    }

    setModalTitle() {
        let title = this.editing ? ' ' : 'Crear ';
        title += 'Zafra de Empresa';
        this.modalTitle = title;
    }

    loadPatchData() {
        if (this.editing) {
            this.detailCompanyFarming = this.patchData;
            this.insuranceHarvestSelected = null;
            this.modalTitle = this.modalTitle + ': <b>' + this.patchData['name'] + '</b>';
            this.activeRanch = this.patchData['active'];
            this.updateFarmingYear(this.patchData['year']);
            this.updatePreffixValue(this.patchData['name']);
            if (this.patchData['insurance_farming'] !== null) {
                this.patchData['insurance_farming']['insurance_company'] = this.patchData['insurance_farming'][
                    'insurance_company'
                ]['id'];
            }
            this.insuranceHarvestSelected =
                this.patchData['insurance_farming'] !== null ? this.patchData['insurance_farming'] : null;

            if (this.insuranceHarvestSelected !== null) {
                this.updateZafraName(this.insuranceHarvestSelected['name']);
            } else {
                this.updateZafraName('');
            }

            let indexCropType = matchedIndexIdInArray(this.cropTypeOptions, this.patchData['harvest_type'].toString());
            if (indexCropType !== -1) {
                this.cropTypeSelected = this.cropTypeOptions[indexCropType];
            }
            this.dateRangeSelected = [this.patchData['start_date'], this.patchData['end_date']];

            if (this.patchData['harvest'] !== null) {
                this.patchData['harvest']['harvest_type'] = this.patchData['harvest_type'];
            }
            this.companySelected = this.patchData['company'];
        }
    }

    selectRanchInList(ranchToSelect) {
        let indexInSelectedRanchs = this.selectedRanchs.findIndex(
            item => item['properties']['customId'] === ranchToSelect['properties']['customId']
        );
        if (indexInSelectedRanchs == -1) {
            let indexRanchToSelected = this.previewItems.findIndex(
                item => item['properties']['customId'] === ranchToSelect['properties']['customId']
            );
            if (indexRanchToSelected !== -1) {
                //I can select it
                let itemToAdd = {
                    item: this.previewItems[indexRanchToSelected],
                    value: true
                };
                this.previewItems[indexRanchToSelected]['selected'] = 'true';
                this.selectedRanchs.push(itemToAdd['item']);
                this.updateSelectedRanchsList(itemToAdd);
            }
        }
        this.sortItemsBySelectedKey();

        this.selectFeaturesInMap();
    }

    ranchToUnselectFromMap(ranchToUnselectFromMap) {
        let indexInSelectedRanchs = this.selectedRanchs.findIndex(
            item => item['properties']['customId'] === ranchToUnselectFromMap['properties']['customId']
        );
        if (indexInSelectedRanchs !== -1) {
            this.selectedRanchs.splice(indexInSelectedRanchs, 1);
        }
        let indexInItemsList = this.previewItems.findIndex(
            item => item['properties']['customId'] === ranchToUnselectFromMap['properties']['customId']
        );
        if (indexInItemsList !== -1) {
            this.previewItems[indexInItemsList]['selected'] = 'false';
        }
        this.selectFeaturesInMap();
    }

    ranchToUnselectFromTable(ranchToUnselect) {
        this.mapCompanyHarvest.unselectFeature(ranchToUnselect);

        this.sortItemsBySelectedKey();

        setTimeout(() => {
            this.selectFeaturesInMap();
        }, 0);
    }

    sortItemsBySelectedKey() {
        this.previewItems.sort(function(a, b) {
            return b['selected'].localeCompare(a['selected']);
        });
    }

    updateSelectedRanchsList(itemSelected) {
        let item = itemSelected;
        if (item['value']) {
            item['item']['selected'] = 'true';
            this.selectedRanchs.push(item['item']);
        } else {
            let indexFeatureToRemove = this.selectedRanchs.indexOf(item['item']);
            if (indexFeatureToRemove !== -1) {
                item['item']['selected'] = 'false';
                this.mapCompanyHarvest.unselectFeature(item['item']);
                this.selectedRanchs.splice(indexFeatureToRemove, 1);
            }
        }
        // this.sortItemsBySelectedKey();
        // this.$set(item['item']['properties'], "customId", item['item']['customId']);
    }

    selectFeaturesInMap() {
        this.mapCompanyHarvest.selectFeature(this.selectedRanchs);
    }

    getSelectedCompany(value) {
        return this.companySelected !== null ? this.companySelected[value] : null;
    }

    getSelectedCropType(value) {
        return this.cropTypeSelected !== null ? this.cropTypeSelected[value] : null;
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    get disableCreateHarvest() {
        if (this.isMultiple) {
            if (this.isSelectHand) {
                this.enableCreateHarvest = false;
                return false;
            } else {
                this.enableCreateHarvest = true;
                return true;
            }
        }
        return false;
    }

    get getSelectedStartYear() {
        return this.dateRangeSelected.length !== 0 ? splitStringByIndex(this.dateRangeSelected[0], 0, 4) : null;
    }

    get getSelectedEndYear() {
        return this.dateRangeSelected.length !== 0 ? splitStringByIndex(this.dateRangeSelected[1], 0, 4) : null;
    }

    get getFileName() {
        return (
            this.prefix +
            ' - ' +
            this.getSelectedCompany('name') +
            ' - ' +
            this.getSelectedCropType('value') +
            ' - ' +
            this.getSelectedEndYear
        );
    }

    get isMultiple() {
        return this.enableMultiple;
    }

    get isSelectHand() {
        return this.firstTab === 'select_hand' ? true : false;
    }

    get enableSubmit() {
        if (!this.isMultiple) {
            return this.baseFarmingIsValid && this.companySelected !== null;
        } else {
            if (this.isSelectHand) {
                return this.baseFarmingIsValid && this.existsSelectedCompanies && this.selectedCompaniesAreValid;
            } else {
                return (
                    this.baseFarmingIsValid &&
                    this.existUploadedFile &&
                    this.selectedFileColumnsAreValid &&
                    this.insuranceHarvestSelected !== null
                );
            }
        }
    }

    get existsSelectedCompanies() {
        return this.itemsSelectedCompanies.length > 0 ? true : false;
    }

    get baseFarmingIsValid() {
        if (
            this.prefix !== '' &&
            this.dateRangeSelected.length > 0 &&
            this.cropTypeSelected !== null &&
            this.dateRangeHarvest.length > 0
        ) {
            if (!this.editing) {
                if (!this.enableCreateSowing) {
                    return true;
                } else {
                    if (this.dateRangeSowing.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    get selectedCompaniesAreValid() {
        return this.invalidSelectedCompanies == 0 ? true : false;
    }

    get existUploadedFile() {
        return this.geoJsonLoaded;
    }

    get selectedFileColumnsAreValid() {
        return this.fileErrorCompanyId ||
            this.fileErrorPolicy ||
            //    this.fileErrorPolicyArea ||
            this.fileErrorHarvest ||
            this.fileCompanyId == null ||
            this.filePolicySelected == null ||
            //    this.fileAreaPolicySelected == null ||
            this.fileHarvestName == null
            ? false
            : true;
    }

    triggerSubmit() {
        this.keepThisModalOpen = false;
        this.scrollToTopOfModal();
        let formData = this.getData();
        if (!this.editing) {
            this.postFarming(formData);
        } else {
            this.patchFarming(formData);
        }
    }

    setDefaultSowingDates() {
        // fecha inicio siembra = fecha inicio zafra
        // fecha fin siembra = fecha inicio zafra + 120 dias
        let startDateZafra = this.dateRangeSelected[0];
        let startDateSowing = startDateZafra;
        let endDateSowing:any = getDateAsMoment(startDateZafra, dateTypes.globalFilterDateFormat);
        endDateSowing = getDateFormattedAsMoment(addTimeToDate(endDateSowing, 120, diffOptions.days));
        this.updateRangeDateSowing([startDateSowing, endDateSowing]);
    }

    setDefaultHarvestDates() {
        // fecha inicio cosecha = fecha fin zafra - 120 dias
        // fecha fin cosecha = fecha fin zafra
        let endDateZafra = this.dateRangeSelected[1];
        let startDateHarvest:any = getDateAsMoment(endDateZafra, dateTypes.globalFilterDateFormat);
        startDateHarvest = getDateFormattedAsMoment(substractTimeToDate(startDateHarvest, 120, diffOptions.days));
        let endDateHarvest = endDateZafra;
        this.updateRangeDateHarvest([startDateHarvest, endDateHarvest]);
    }

    getData() {
        let baseData = {
            insurance_farming: this.insuranceHarvestSelected !== null ? this.insuranceHarvestSelected['id'] : null,
            prefix: this.prefix,
            start_date: this.dateRangeSelected[0],
            end_date: this.dateRangeSelected[1],
            create_harvest: this.enableCreateHarvest,
            harvest_start_date: this.dateRangeHarvest[0],
            harvest_end_date: this.dateRangeHarvest[1],
            active: this.activeRanch,
            harvest_type: Number(this.cropTypeSelected['id'])
        };
        if (this.editing) {
            this.$set(baseData, 'id', this.patchData['id']);
            this.$set(baseData, 'year', this.farmingYear);
            this.$set(baseData, 'prefix', '');
        } else {
            this.$set(baseData, 'create_sowing', this.enableCreateSowing);
            if (this.enableCreateSowing) {
                //switch crear siembra
                this.$set(baseData, 'sowing_start_date', this.dateRangeSowing[0]);
                this.$set(baseData, 'sowing_end_date', this.dateRangeSowing[1]);
            }
        }

        if (this.isMultiple) {
            //alta multiple
            if (this.isSelectHand) {
                //seleccionar a mano
                this.$set(baseData, 'company_ids', getIdsFromList(this.itemsSelectedCompanies));
            } else {
                let form_data = new FormData();
                let fileData: any = {};
                if (this.selectedRanchs.length > 0) {
                    //submit selected ranchs
                    fileData = {
                        type: 'FeatureCollection',
                        features: this.selectedRanchs
                    };
                    fileData = new Blob([JSON.stringify(fileData)]);
                } else {
                    fileData = this.geoJsonFormData;
                }

                form_data.append('file', fileData);
                form_data.append('insurance_farming', baseData['insurance_farming']);
                form_data.append('prefix', baseData['prefix']);
                form_data.append('start_date', baseData['start_date']);
                form_data.append('end_date', baseData['end_date']);
                form_data.append('active', JSON.stringify(baseData['active']));
                form_data.append('harvest_type', JSON.stringify(baseData['harvest_type']));
                form_data.append('company_id_field', this.fileCompanyId['value']);
                form_data.append('policy_field', this.filePolicySelected['value']);
                form_data.append('ranch_field', this.fileHarvestName['value']);
                form_data.append('harvest_start_date', this.dateRangeHarvest[0]);
                form_data.append('harvest_end_date', this.dateRangeHarvest[1]);
                form_data.append('create_sowing', JSON.stringify(this.enableCreateSowing));

                if (this.enableCreateSowing) {
                    //switch crear siembra
                    form_data.append('sowing_start_date', this.dateRangeSowing[0]);
                    form_data.append('sowing_end_date', this.dateRangeSowing[1]);
                }
                return form_data;
            }
        } else {
            this.$set(baseData, 'company', this.companySelected['id']);
            if (!this.editing) {
                this.$set(baseData, 'name', this.getFileName);
            } else {
                this.$set(baseData, 'name', this.prefix);
            }
        }

        return baseData;
    }

    postFarming(formData) {
        //if alta multiple is disabled
        if (!this.isMultiple) {
            this.showLoadingDialog('Creando Zafra de Empresa');
            this.postSimpleFarming(formData);
        } else {
            if (this.isSelectHand) {
                this.showLoadingDialog('Creando Zafra de Empresa');
                this.postCompanyMultiCompanyList(formData);
            } else {
                this.showLoadingDialog(
                    'Creando Zafras de Empresa <br> <small>(Ésta acción puede tomar unos minutos)</small>'
                );
                this.postFarmingGeoJSON(formData);
            }
        }
    }

    postSimpleFarming(formData) {
        InsuranceServices.postSimpleFarming(formData)
            .then(res => {
                let msg = res['message'];
                let newFarming = res['new_farming'];
                newFarming['company'] = {
                    id: formData['company'],
                    name: this.companySelected['name']
                };
                this.$emit('add-new-company-farming', newFarming);
                this.showSuccessLoadingDialog(res, msg);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo crear la zafra');
            });
    }

    patchFarming(formData) {
        this.showLoadingDialog('Modificando Zafra de Empresa');
        InsuranceServices.patchFarming(formData)
            .then(res => {
                let msg = res['data']['message'];
                let newFarming = res['data']['farming'];
                newFarming['company'] = {
                    id: formData['company'],
                    name: this.companySelected['name']
                };
                this.showSuccessLoadingDialog(res.data, 'Zafra de Empresa modificada');
                this.$emit('update-company-farming', newFarming);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo modificar la zafra de empresa');
            });
    }

    //post farming multiple (company list)
    postCompanyMultiCompanyList(formData) {
        InsuranceServices.postFarmingCompanyList(formData)
            .then(res => {
                this.$emit('add-new-company-farming', res);
                 this.$_successLoadingDialog({
                    response: res,
                    alternative_msg: 'Zafra creada con éxito',
                    timeout: null
                });
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'Ocurrio un error');
            });
    }

    //post farming multiple (geoJSON)
    postFarmingGeoJSON(formData) {
        InsuranceServices.postFarmingGeoJSON(formData)
            .then(res => {
                this.$emit('add-new-company-farming', res);
                let msg = res['message'];
                this.$_successLoadingDialog({
                    response: res,
                    alternative_msg: 'Zafra creada con éxito',
                    timeout: null
                });
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'Ocurrio un error');
            });

        // for (var pair of formData.entries()) {
        //     console.log(pair[0]+ ', ' + pair[1]);
        // }
    }

    filterCompanies(insuranceCompany) {
        let insuranceCompanyId = insuranceCompany !== null ? insuranceCompany['insurance_company'] : null;
        if (insuranceCompanyId !== null) {
            let indexSecuredCompany = matchedIndexIdInArray(this.optionsInsuranceCompanies, insuranceCompanyId);

            if (indexSecuredCompany !== -1) {
                this.optionsCompany = this.optionsInsuranceCompanies[indexSecuredCompany]['secured_companies'];
                this.setAvailableCompanies(true);
            }
        } else {
            this.setAvailableCompanies(false);
        }
    }
    setAvailableCompanies(value) {
        let items: Array<object> = [];
        if (value && this.enableMultiple) {
            items = this.optionsCompany.map(element => ({
                harvest: this.insuranceHarvestSelected['name'],
                insurance_harvest_id: this.insuranceHarvestSelected['id'],
                ...element
            }));
        } else {
            items = [];
        }
        this.itemsAvailableCompanies = items;
    }

    checkIfSelectedCompaniesBelongsToSelectedHarvest() {
        this.invalidSelectedCompanies = 0;
        if (this.insuranceHarvestSelected !== null && this.isSelectHand) {
            let selectedHarvestId = this.insuranceHarvestSelected['id'];
            for (let index = 0; index < this.itemsSelectedCompanies.length; index++) {
                const selected_company = this.itemsSelectedCompanies[index];

                if (selected_company['insurance_harvest_id'] !== selectedHarvestId) {
                    this.$set(selected_company, 'alerts', {
                        msgs: ['Ésta empresa no pertenece a la aseguradora seleccionada']
                    });
                    this.invalidSelectedCompanies++;
                } else {
                    this.$set(selected_company, 'alerts', { msgs: [] });
                }
            }
        }
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: null
        });
        if (!this.keepThisModalOpen) {
            this.closeModal();
        }
        removeItemFromLocalStorage('mv_harvest_res');
        removeItemFromLocalStorage('mv_sowing_res');
        EventBus.$emit(TypeEventBus.REFRESH_MACHINE_VIEW);
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    createNewInsuranceFarming() {
        this.editInsuranceHarvest = false;
        this.visibilityModalInsuranceHarvest(true);
    }

    selectInsuranceFarming(newItem) {
        //select new insurance farming
        let indexInFarmingList = matchedIndexIdInArray(this.optionsFarmings, newItem['id']);
        if (indexInFarmingList !== -1) {
            this.insuranceHarvestSelected = this.optionsFarmings[indexInFarmingList];
        }
    }

    modifyInsuranceHarvest() {
        this.loadingPatchInsuranceFarming = true;
        InsuranceServices.getInsuranceFarmingDetail(this.insuranceHarvestSelected['id'])
            .then(res => {
                res['insurance_farming'] = this.insuranceHarvestSelected['id'];
                this.insuranceFarmingToPatch = res;
                this.editInsuranceHarvest = true;
                this.visibilityModalInsuranceHarvest(true);
                this.loadingPatchInsuranceFarming = false;
            })
            .catch(res => {
                this.loadingPatchInsuranceFarming = false;
            });
    }

    updateAvailableCompaniesSelectedRows(items) {
        this.itemsAvailableCompaniesSelected = items;
    }

    addCompanyToSelectedOnes() {
        this.itemsSelectedCompanies = addItemsToListIfAreNotAdded(
            this.itemsSelectedCompanies,
            this.itemsAvailableCompaniesSelected,
            'id'
        );
        this.itemsAvailableCompaniesSelected = [];
    }

    updateAvailableSelectedCompanies(items) {
        this.selectedCompaniesToExclude = items;
    }

    removeCompanySelected(itemsToExclude) {
        this.itemsSelectedCompanies = removeItemsFromList(this.itemsSelectedCompanies, itemsToExclude, 'id');
        this.selectedCompaniesToExclude = [];
        this.checkIfSelectedCompaniesBelongsToSelectedHarvest();
    }

    selectHandClick() {
        this.filterCompanies(this.insuranceHarvestSelected);
        this.enableCreateHarvest = false;
    }

    excludeCompanySelected(item) {
        this.removeCompanySelected([item]);
    }

    statusFormatter(value) {
        return value ? 'Cosechando' : '-';
    }

    cropTypeFormatter(cropTypeId) {
        let allCropTypes = this.$_getInsuranceProperties['harvest_type'];
        if (allCropTypes) {
            let cropTypeIndex = allCropTypes.findIndex(item => Number(item['id']) === cropTypeId);
            if (cropTypeIndex !== -1) {
                return allCropTypes[cropTypeIndex]['value'];
            }
        }
    }

    deleteSowingRanchs(msg) {
        this.keepThisModalOpen = true;
        this.scrollToTopOfModal();
        this.showLoadingDialog(msg);
    }

    clearGeojsonFile() {
        this.geoJsonFormData = [];
        this.geoJsonLoaded = false;
        // this.geoJsonFile = [];
        this.fileErrorCompanyId = false;
        this.fileErrorPolicy = false;
        // this.fileErrorPolicyArea = false;
        this.fileErrorHarvest = false;
    }

    get mapCompanyHarvest(): HTMLFormElement {
        return this.$refs.mapCompanyHarvest as HTMLFormElement;
    }

    tableRanchClicked(item) {
        let selectedValue = item['selected'] === 'true' ? 'false' : 'true';
        this.$set(item, 'selected', selectedValue);

        if (item['selected'] === 'true') {
            this.selectRanchInList(item);
        } else {
            this.ranchToUnselectFromTable(item);
        }
    }

    scrollToTopOfModal() {
        $('.dialog-slot').scrollTop(0);
    }

    updateFarmingYear(value){
        this.farmingYear = value;
    }


    updateFarmingDetail() {
        // console.log("farming detail updateFarmingDetail");
        this.$emit('update-company-farming');
        this.detailCompanyFarming = null;
        InsuranceServices.getFarmingDetail(this.patchData['id'])
            .then(res => {
                this.patchData = res;
                res['farming_id'] = this.patchData['farming_id'];
                this.detailCompanyFarming = res;
            })
            .catch(error => {
                this.detailCompanyFarming = null;
            });
    }

    @Emit()
    closeModal() {
        
    }

    closeModalInsuranceHarvest(){
        this.visibilityModalInsuranceHarvest(false)
        this.$router.push(NAME_ROUTES.INSURANCE_FARMING_MANAGEMENT);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }
}
